import React, { useState } from 'react'

// components
import Heading from '../../../components/text/Heading/Heading.component'

// collections
import PurchaseOrderListWithSearch from './collections/PurchaseOrdersListWithSearch/PurchaseOrdersListWithSearch.collection'

// forms
import CreatePurchaseOrderFormController from './forms/CreatePurchaseOrder.form.controller'

//apollo
import { GET_ALL_PURCHASE_ORDERS_WITH_FULL_DETAIL } from '../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries';

//wrappers 
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper';

// mui
import { Grid, Container, Typography } from '@mui/material';

export default function PurchaseOrderList({ ...pageProps }) {

    // modals
    const [showAdd, setShowAdd] = useState(false)
    
    return (<div id="PurchaseOrderList">
        <CreatePurchaseOrderFormController 
            visible={showAdd}
            closeForm={() => setShowAdd(false)}
        />

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6}><Typography variant="h2">Purchase Orders</Typography></Grid>
            </Grid>
        </Container>

        <WithGqlQuery
            component={PurchaseOrderListWithSearch}
            query={GET_ALL_PURCHASE_ORDERS_WITH_FULL_DETAIL}
            onAddClick={() => setShowAdd(true)}
            pageProps={pageProps}
        />

    </div>)
}